export default function(value) {
  if (!value) {
    return true;
  }
  return /^[0-9-+ ]*$/i.test(value);
}
